import * as React from 'react';
import { observer } from 'mobx-react';

// Types
import { ISelectablePeopleItem } from './AppNetworkPeopleSearch';

// Components
import Avatar from '../../components/Avatar';
import Box from '../../components/Box/Box';
import Divider from '../../components/Divider';
import Icon from '../../components/Icon';
import IconButton from '../../components/IconButton';
import List, {
  ListItem,
  ListItemText,
  ListItemSecondaryAction
} from '../../components/List';
import Typography from '../../components/Typography';

// Component
interface IProps {
  selectPeople: ISelectablePeopleItem[];
  onRemove: (item: ISelectablePeopleItem) => void;
}

const QuestionDialogPeople = (props: IProps) => {
  if (props.selectPeople.length === 0) {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Typography type="title">You haven't selected any audience.</Typography>
        <Typography type="subheading">
          Please select some people before proceeding.
        </Typography>
      </div>
    );
  }
  return (
    <div>
      <Box pa={3}>
        <Typography type={'title'}>Selected People</Typography>
      </Box>
      <Divider />
      <List>
        {props.selectPeople.map(item => (
          <ListItem key={item.userId}>
            <Avatar
              alt={`${item.firstName} ${item.lastName}`}
              src={item.photoUrl || 'http://i.imgur.com/wkbr0Z0.png'}
            />
            <ListItemText primary={`${item.firstName} ${item.lastName}`} />
            <ListItemSecondaryAction>
              <IconButton onClick={() => props.onRemove(item)}>
                <Icon>delete</Icon>
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

// Exports
export default observer(QuestionDialogPeople);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/QuestionDialogPeople.tsx